import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect } from "react";
import { OrderName } from "../../enums";
import { useOrderDetails } from "../../contexts/orderDetails";
import { useFormik } from "formik";
import { basePath } from "../config";
import classNames from "classnames";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/auth";

const validate = (values) => {
  const errors = {};

  // if (!values.note) {
  //     errors.note = 'Required';
  // }

  return errors;
};

async function doSubmit(
  values,
  action,
  isEditMode,
  activeUser,
  orderStateData,
  orderDetails,
  formik,
  setOrderDetails,
  setOrderStateData
) {
  try {
    const res = await fetch(
      basePath + (isEditMode ? "editOrderNotes" : "changeOrderStatus"),
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify({
          ...values,
          type: orderStateData?.type,
          id: orderDetails.id,
        }),
      }
    );

    const data = await res.json();
    if (res.status === 401) {
      formik.resetForm({ values: values });
      document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      toast.error(data.message);
      return 0;
    }

    if (data.status) {
      setOrderDetails(JSON.parse(data.data));
      setOrderStateData(null);
      formik.setFieldValue("note", "");
      formik.resetForm();
      toast.success(data.message);
    } else {
      // TODO:: handle form while API fails
      // setOrders(null)
      formik.resetForm({ values: values });
      toast.error("error: " + data.message);
      console.error("error: " + data.message);
    }
  } catch (error) {
    // TODO:: handle form while API fails
    formik.resetForm({ values: values });
    toast.error("error: " + error);
    console.error("srartOrder:: api calling fail =>", error);
  }
}

export default function OrderStatusForm({ orderStateData, setOrderStateData }) {
  const [{ orderDetails }, { setOrderDetails }] = useOrderDetails();
  const isOpen = !!orderStateData;
  const [{ activeUser }] = useAuth();

  const isEditMode = !!orderStateData?.isEditMode;

  useEffect(() => {
    if (isEditMode) {
      if (orderStateData?.type === "slitting_note") {
        formik.setFieldValue("note", orderDetails?.slitting_note);
      } else {
        formik.setFieldValue(
          "note",
          orderDetails?.status?.[orderStateData?.type + "_note"]
        );
      }
    } else {
      formik.setFieldValue("note", "");
    }
  }, [isEditMode]);

  function closeModal() {
    setOrderStateData(null);
    formik.setFieldValue("note", "");
  }

  const formik = useFormik({
    initialValues: {
      note: "",
    },
    validate,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values, action) => {
      doSubmit(
        values,
        action,
        isEditMode,
        activeUser,
        orderStateData,
        orderDetails,
        formik,
        setOrderDetails,
        setOrderStateData
      );
    },
  });

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  {OrderName[orderDetails.order_type]} Order Status
                </Dialog.Title>
                <form
                  className="mt-2 grid gap-4"
                  onSubmit={formik.handleSubmit}
                >
                  <div>
                    <label className="block col-span-2">
                      <span className="block text-sm font-medium text-slate-700 capitalize mb-2">
                        {orderStateData?.type?.split("_").join(" ")}
                      </span>
                      <textarea
                        name="note"
                        onChange={formik.handleChange}
                        value={formik.values.note}
                        className={classNames(
                          "mt-1 block w-full px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400 disabled:bg-slate-300",
                          formik.errors?.note && "border-red-600"
                        )}
                        rows="5"
                      ></textarea>
                    </label>
                    {formik.errors.note ? (
                      <span className="text-sm text-red-600">
                        {formik.errors?.note}
                      </span>
                    ) : null}
                  </div>

                  <div className="mt-4 flex justify-end gap-3">
                    <button
                      type="submit"
                      disabled={formik.isSubmitting}
                      className={classNames(
                        "inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2",
                        formik.isSubmitting && "disabled:bg-slate-300"
                      )}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
